import api from './api';

const billingService = {
  // Unified view of all project-based invoices
  getProjectInvoices: async (params = {}) => {
    const response = await api.get('/billing/invoices', { params });
    return response.data;
  },

  // RENAME THIS to match your component's call
  createProjectInvoice: async (data) => {
    const response = await api.post('/billing/invoices', data);
    return response.data;
  },

  getContractInvoices: async (params = {}) => {
    const response = await api.get('/billing/contracts/invoices', { params });
    return response.data;
  },

  // Ensure this points to the finance endpoint you mentioned
  generateContractInvoice: async (contractId, data) => {
    const response = await api.post('/finance/contracts/invoices', { ...data, contractId });
    return response.data;
  },

  // Combined analytics for the Billing Dashboard
  getBillingSummary: async () => {
    try {
      // Assuming a backend endpoint for aggregate data, or fetch both and combine
      const [projects, contracts] = await Promise.all([
        api.get('/billing/invoices'),
        api.get('/billing/contracts/invoices')
      ]);
      return {
        projectTotal: projects.data.totalCount || 0,
        contractTotal: contracts.data.totalCount || 0,
        combinedData: [...(projects.data.data || []), ...(contracts.data.data || [])]
      };
    } catch (error) {
      throw error.response?.data || error;
    }
  },

};

export default billingService;